module.exports = __webpack_public_path__ + "static/event7-9053e2f83cf51004afbf4878ca500507.jpg";